// Booking panel on the tour page: date/price calendar, passengers, summary and mobile dock.
export default {
  bookingUi: {
    perAdult: 'par adulte',
    secureNote: 'Réglez l’acompte par Pix (QR code ou copier-coller). Vous recevez votre bon dès la confirmation.',
    calendar: {
      prevMonth: 'Mois précédent',
      nextMonth: 'Mois suivant',
      today: 'Aujourd’hui',
      selected: 'Sélectionné',
      unavailable: 'Indisponible',
      lowest: 'Prix le plus bas du mois',
      legend: 'Légende du calendrier',
      noDate: 'Aucune date choisie',
      noDateHint: 'Touchez un jour pour voir son prix.',
      pricePerAdult: '{{price}} par adulte',
    },
    passengers: {
      title: 'Passagers',
      adults: 'Adultes',
      children: 'Enfants',
      babies: 'Bébés',
      adultsAge: '10 ans et plus',
      childrenAge: '5 à 9 ans',
      babiesAge: '0 à 4 ans',
      each: '{{price}} chacun',
    },
    summary: {
      title: 'Récapitulatif',
      adultsLine_one: '{{count}} adulte × {{price}}',
      adultsLine_other: '{{count}} adultes × {{price}}',
      childrenLine_one: '{{count}} enfant × {{price}}',
      childrenLine_other: '{{count}} enfants × {{price}}',
      babiesLine_one: '{{count}} bébé',
      babiesLine_other: '{{count}} bébés',
      depositNow: 'Acompte maintenant · Pix',
      fullNow: 'Paiement total maintenant · Pix',
    },
    errors: {
      closed: 'Aucun départ à cette date. Choisissez un autre jour.',
    },
    dock: {
      label: 'Réservation rapide',
      from: 'À partir de',
      chooseDate: 'Choisir la date',
    },
  },
};
